var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 10,
    viewBox: "0 0 5 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.27609 5.0002L0.271065 1.99517C-0.00230172 1.7218 -0.00230172 1.27859 0.271065 1.00522C0.544432 0.731853 0.987648 0.731853 1.26102 1.00522L4.76102 4.50522C5.03438 4.77859 5.03438 5.2218 4.76102 5.49517L1.26102 8.99517C0.987648 9.26854 0.544432 9.26854 0.271065 8.99517C-0.00230172 8.7218 -0.00230172 8.27859 0.271065 8.00522L3.27609 5.0002Z",
    fill: "#4B4AD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4326d7b72134ae2ff241ac6511a6c033.svg";
export { ForwardRef as ReactComponent };